import _ from 'lodash';
import React from 'react';

import { DataTableProps } from './DataTable';
import { getDataTableColumns } from './DataTableMetadataHelpers';
import DataTableSortColumn from './DataTableSortColumn';
import { SortDirection } from './withSorting';

export interface WithExternalSortingProps {
    sortColumn?: string;
    sortDirection?: SortDirection;
    updateSort: (sortColumn?: string, sortDirection?: string) => void;
}

export default <P extends DataTableProps<V>, V>(Component: React.ComponentType<P>) =>
    class WithExternalSorting extends React.Component<P & WithExternalSortingProps> {
        render() {
            const { children, data, sortColumn, sortDirection, updateSort, ...rest } = this.props;

            const columns = getDataTableColumns(children, data);

            return <Component data={this.props.data} {...rest as any}>{columns && columns.map((column: any) => {
                if (!DataTableSortColumn.prototype.isPrototypeOf(column.type.prototype) && DataTableSortColumn.prototype !== column.type.prototype) {
                    return column;
                }

                const { heading, ...rest } = column.props;

                return <DataTableSortColumn<V, any> key={column.props.prop} heading={<button className="btn btn-link text-left b-0 p-0 align-baseline" style={{fontWeight: "bold"}} onClick={() => this.clickSortHeading(column.props.prop)}>{heading}{this.getSortIndicator(column.props.prop)}</button>} {...rest} />
            })}</Component>;
        }

        clickSortHeading(sortColumn: string) {
            if (this.props.sortColumn !== sortColumn) {
                this.props.updateSort(sortColumn, "ascending");
            } else if (this.props.sortDirection !== "descending") {
                this.props.updateSort(sortColumn, "descending");
            } else {
                this.props.updateSort(undefined, undefined);
            }
        }

        getSortIndicator(sortColumn: string): React.ReactNode {
            if (this.props.sortColumn !== sortColumn) {
                return <React.Fragment></React.Fragment>;
            }

            if (this.props.sortDirection == "descending") {
                return <i className="material-icons d-inline-block align-middle" style={{fontSize: "16px"}}>keyboard_arrow_down</i>;
            }

            return <i className="material-icons d-inline-block align-middle" style={{fontSize: "16px"}}>keyboard_arrow_up</i>;
        }
    }
